import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { installSessionHeader } from "./util/analytics";

installSessionHeader();

const root = createRoot(document.getElementById("root"));
root.render(<App />);
